
import { ReactElement } from "react";

// compoments
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from '@mui/material/Divider';

// language
import { injectIntl, IntlShape } from 'react-intl';

// types
import { HomePageTypes } from 'types/types';

type Props = {
    intl: IntlShape,
    nameCard: keyof HomePageTypes,
    icon: ReactElement | JSX.Element,
    homePageData: HomePageTypes,
}

const HomePageCard = ( {intl, nameCard, icon, homePageData}: Props ) => {

    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);

    const titleValue =
    nameCard === 'income'
      ? homePageData?.income?.currentMonth
      : nameCard === 'boats'
      ? homePageData.boats.inUse 
      : nameCard === 'orders'
      ? homePageData.orders.active
      : (homePageData[nameCard] as { total: number }).total; //users, reservations
      

    const titleName = () => {
        if ( nameCard === 'income' ) {            
            return `${(intl.formatMessage({id:'homePage.income'}))}\u00A0${month}/${year}`;
        } else if ( nameCard === 'users' ) {
            return (intl.formatMessage({id:'homePage.users'}));
        } else if ( nameCard === 'orders' ) {
            return (intl.formatMessage({id:'homePage.orders'}))
        } else if ( nameCard === 'reservations' ) {
            return (intl.formatMessage({id:'homePage.reservations'}))
        } else if ( nameCard === 'boats' ) {
            return (intl.formatMessage({id:'homePage.inTransit'}))
        }
    }

    const bodyName = () => {
        if ( nameCard === 'income' ) {
            return (intl.formatMessage({id:'homePage.income.bodyName'}));
        } else if ( nameCard === 'users' ) {
            return (intl.formatMessage({id:'homePage.users.bodyName'}));
        } else if ( nameCard === 'orders' ) {
            return (intl.formatMessage({id:'homePage.orders.bodyName'}))
        } else if ( nameCard === 'reservations' ) {
            return (intl.formatMessage({id:'homePage.reservations.bodyName'}))
        }
    }

    const bodyValue =
    (nameCard === 'orders' || nameCard === 'reservations')
      ? homePageData[nameCard].last24h
      : nameCard === 'income'
      ? homePageData[nameCard].yesterday
      : homePageData.users.lastMonth;
      


    return (
        <MDBox        
            sx= {{ width: "100%", display: "flex",
                flexDirection: "column",
                padding: "0.8rem 1.5rem", backgroundColor: "#ffffff",
                borderRadius: "0.75rem",
            }}
        >

            <MDBox
                sx= {{ 
                    width: "100%", display: "flex", flexDirection: "column",                
                }}
            >
                <MDBox 
                    sx= {{ 
                        width: "100%", display: "flex", flexDirection: "row", 
                        justifyContent: "space-between",
                    }}
                >
                    <MDBox className= "badge"
                        sx={{ 
                            // backgroundColor: "#17C063",
                            p: 1, mt: -4, ml: 0,
                            borderRadius: ({ borders: { borderRadius } }) => borderRadius.xl, 
                        }}
                            display="grid"
                            justifyContent="center"
                            alignItems="center"
                            bgColor="#17C063"
                            color="white"
                            width="4.5rem"
                            height="4.5rem"
                            shadow="md"
                            borderRadius="lg"
                            variant="gradient"  
                            fontSize= "2.2rem"        
                        >
                        {icon}
                    </MDBox>

                    <MDBox
                    sx={{
                        display: "flex", flexDirection: "column",
                        alignItems: "flex-end",
                    }}
                    >
                    <MDTypography
                        sx={{
                            fontSize: "0.875rem", fontWeight: "400",
                            color: "#807E7B",
                        }}
                    >
                        {titleName()}
                    </MDTypography>
                    <MDTypography
                        sx={{
                            fontSize: "1.5rem", fontWeight: "700",
                        }}
                    >
                        {nameCard === 'income' ? titleValue+intl.formatMessage({ id: 'currency' }) : titleValue ?? '-'}
                    </MDTypography>
                    </MDBox>            
                </MDBox>
            </MDBox>

            { (nameCard !== 'boats' ) && (
                <>
                    <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ 
                            width: '100%', height: '1px', marginTop: "0.3rem", 
                            marginBottom: "0rem", background: 'black',
                        }}
                    />            
                
                    <MDBox
                        sx={{
                            display: "flex", flexDirection: "row",
                            alignItems: "flex-start",  marginTop: "0.3rem",
                        }}
                    >
                        <MDTypography 
                            sx={{
                                fontSize: "0.875rem", fontWeight: "700",
                                color: "#309B0A",
                            }}
                        >
                            +{(nameCard === 'income' ? bodyValue+intl.formatMessage({ id: 'currency' }) : bodyValue) ?? '-'}&nbsp;
                        </MDTypography>
                        <MDTypography
                            sx={{
                                fontSize: "0.875rem", fontWeight: "400",
                                color: "#807E7B",
                            }}
                        >
                            {bodyName()}
                        </MDTypography>
                    </MDBox>
                    { nameCard === 'orders' && (
                        <>
                            <Divider
                                orientation="horizontal"
                                flexItem
                                sx={{ 
                                    width: '100%', height: '1px', marginTop: "0.3rem", 
                                    marginBottom: "0rem", background: 'black',
                                }}
                            />
                            <MDBox
                                sx={{
                                    display: "flex", flexDirection: "row",
                                    alignItems: "center", justifyContent: "space-between",
                                    marginTop: "0.3rem",
                                }}
                            >
                                <MDTypography 
                                    sx={{
                                        fontSize: "0.875rem", fontWeight: "400",
                                        color: "#1D1C1B",
                                    }}
                                >
                                    {`${(intl.formatMessage({id:'homePage.orders.footerName'}))}\u00A0${month}/${year}`}
                                </MDTypography>
                                <MDTypography
                                    sx={{
                                        fontSize: "0.875rem", fontWeight: "700",
                                        color: "#1D1C1B",
                                    }}
                                >
                                    {homePageData.orders.currentMonth}
                                </MDTypography>
                            </MDBox>
                        </>
                    )}
                </>

            )}

        </MDBox>
    )
}

export default injectIntl(HomePageCard);